import { useState } from "react";

import type { CollaboratorDetailUiT } from '../domain/ui/requestDetail.model';

import { VACATION_REQUESTS_STRINGS } from "../constants/strings";

type CollaboratorCardPropsT = {
  collaborator: CollaboratorDetailUiT;
};

const CollaboratorCard = ({ collaborator }: CollaboratorCardPropsT) => {
  const [avatarError, setAvatarError] = useState(false);
  const [avatarLoading, setAvatarLoading] = useState(true);

  const handleAvatarLoaded = () => {
    setAvatarLoading(false);
  };

  const handleAvatarError = () => {
    setAvatarError(true);
    setAvatarLoading(false);
  };

  const fullNameSplit = collaborator?.fullName?.trim().split(" ");

  const initials =
    fullNameSplit?.length > 1
      ? `${fullNameSplit[0][0]}${fullNameSplit[fullNameSplit.length - 1][0]}`
      : (collaborator?.fullName?.substring(0, 2).toUpperCase() ?? "—");

  return (
    <div className="flex gap-3">
      {collaborator?.avatar && !avatarError ? (
        <>
          {avatarLoading && (
            <div
              aria-hidden="true"
              className="w-16 h-16 rounded-full bg-gray-200 animate-pulse shrink-0"
            />
          )}
          <img
            src={collaborator.avatar}
            alt={collaborator.fullName}
            className={`w-16 h-16 rounded-full object-cover shrink-0 ${avatarLoading ? "hidden" : ""}`}
            onLoad={handleAvatarLoaded}
            onError={handleAvatarError}
          />
        </>
      ) : (
        <div
          role="img"
          aria-label={collaborator?.fullName ?? "Avatar del colaborador"}
          className="w-16 h-16 rounded-full bg-primary-PCP001 flex items-center justify-center text-white font-semibold text-xl shrink-0"
        >
          {initials}
        </div>
      )}
      <dl className="flex flex-col gap-0.5 min-w-0">
        <dt className="sr-only">Nombre</dt>
        <dd
          title={collaborator.fullName}
          className="font-semibold text-primary-PCP001 truncate"
        >
          {collaborator.fullName}
        </dd>
        {collaborator?.schedule && (
          <>
            <dt className="sr-only">Turno</dt>
            <dd className="text-secondaryText">
              {VACATION_REQUESTS_STRINGS.DETAIL_SHIFT_LABEL}{" "}
              {collaborator.schedule.scheduleDisplay} hrs.
            </dd>
          </>
        )}
        <dt className="sr-only">Código</dt>
        <dd className="text-secondaryText">
          {VACATION_REQUESTS_STRINGS.DETAIL_CODE_LABEL}{" "}
          {collaborator?.code ?? "—"}
        </dd>
      </dl>
    </div>
  );
};

export default CollaboratorCard;
